import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const websitePageStateSelector = (state: State) => state.websitePage;

export const websitePagesSelector = createSelector(
  websitePageStateSelector,
  (state) => state.pages
);

export const websitePageSelector = createSelector(
  websitePageStateSelector,
  (state) => state.page
);

export const websitePageLoadFailedSelector = createSelector(
  websitePageStateSelector,
  (state) => state.pageLoadFailed
);

export const websiteFormsSelector = createSelector(
  websitePageStateSelector,
  (state) => state.forms
);

export const editorContentSelector = createSelector(
  websitePageStateSelector,
  (state) => state.editorContent
);

export const selectedBlockIdSelector = createSelector(
  websitePageStateSelector,
  (state) => state.selectedBlockId
);

export const editorViewModeSelector = createSelector(
  websitePageStateSelector,
  (state) => state.viewMode
);
